import styled from 'styled-components'
import {Wrapper, LinkWrapper,Link} from 'components/SocialNav/styles'

export const LanguageWrapper = styled(Wrapper)`
    position: fixed;
    top: 45px;
    right: 58px;
    z-index: 6;
    @media screen and (max-width: ${({theme})=>theme.breakpoints.tabletSmall}){
        top: 130px;
        right: 42px;
    }
    @media screen and (max-width: ${({theme})=>theme.breakpoints.phoneBig}){
        top: 75px;
        right: unset;
        left: 45px;
    }
    @media screen and (max-width: 401px){
        left: 20px;
    }
`
export const LanguageLinkWrapper = styled(LinkWrapper)`
    /* &.active{
        color: ${({theme})=>theme.color.white};
    } */
`
export {Link}